import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapTutorialTypeOptions = (
  option: UCM.TutorialTypeOptionRawType,
): UCM.TutorialTypeOptionType => ({
  value: option.code,
  label: option.name,
});

const getTutorialTypeOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.TutorialTypeOptionRawType>
  >(API.GET.tutorialTypeOptions);
  return data.data.map(({ attributes }) => mapTutorialTypeOptions(attributes));
};

export const useGetTutorialTypeOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.TUTORIAL_TYPE_OPTIONS],
    queryFn: getTutorialTypeOptions,
    staleTime: 1000 * 60 * 5,
    ...config,
  });
};
